<template>
	<section class="container-file" :id="[index]">
		<div class="container">
			<div class="row">
				<div class="file-block col-12">
					<h2> {{ fileData.config.title }} </h2>
				</div>
			</div>
			<div class="file-box">
				<div class="row justify-content-center">
					<div class="col-lg-3 col-md-4 text-center file2" v-for="(file, index) in fileData.config.files" :key="index">
						<a :href="`${file.url}`">
							<div class="icon">
								<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 40">
									<defs></defs>
									<path id="long-arrow-alt-down-solid" class="cls-1"
										d="M12.36,25.51V8.67A.69.69,0,0,0,11.65,8H8.35a.69.69,0,0,0-.71.67V25.51H4.92a1.34,1.34,0,0,0-1.4,1.26,1.32,1.32,0,0,0,.4,1L9,32.6a1.48,1.48,0,0,0,2,0l5.08-4.8a1.33,1.33,0,0,0,0-1.88,1.34,1.34,0,0,0-1-.41Z" />
								</svg>
							</div>
							<span>{{ file.caption }}</span>
						</a>
					</div>
					<div class="col-lg-3 col-md-4 text-center file2">
						<a href="javascript:window.print()">
							<div class="icon">
								<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
									<defs></defs>
									<path id="print-solid" class="cls-1"
										d="M24.38,12.37V6.77a1.61,1.61,0,0,0-.46-1.1L21.71,3.45A1.59,1.59,0,0,0,20.6,3H7.19A1.57,1.57,0,0,0,5.62,4.56h0v7.81A3.12,3.12,0,0,0,2.5,15.49V21a.78.78,0,0,0,.78.78H5.62v4.69A1.58,1.58,0,0,0,7.19,28H22.81a1.56,1.56,0,0,0,1.57-1.56V21.74h2.34A.78.78,0,0,0,27.5,21V15.49A3.12,3.12,0,0,0,24.38,12.37Zm-3.13,12.5H8.75V18.11h12.5Zm0-9.9H8.75V6.12h9.37V8.46a.78.78,0,0,0,.79.78h2.34Zm2.34,2.48a1.18,1.18,0,1,1,1.18-1.18,1.18,1.18,0,0,1-1.18,1.18Z" />
								</svg>
							</div>
							<span>Druckversion</span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
export default {
	props: {
		fileData: {
			type: Object
		},
		index: {
			type: Number
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/fileComponent.scss";

.cls-1 {
	fill: var(--mainColor);
}
</style>